import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { useLiveQuery } from "dexie-react-hooks";
import db from "../../../db";
import { useSellarCurrentBusiness } from "../../useSellarCurrentBusiness.shared";

export function useDraftOrders() {
  const { business } = useSellarCurrentBusiness();

  const orders = useLiveQuery(() => {
    if (!business || (!business.Supplier?.id && !business.Retailer?.id))
      return [];
    return db.draftOrders
      .where(
        business.Supplier
          ? {
              SupplierId: business.Supplier.id,
              initiator: "supplier",
            }
          : {
              RetailerId: business.Retailer?.id,
              initiator: "retailer",
            },
      )
      .toArray();
  }, [business]);

  const deleteOrder = async (
    order: Pick<
      OrderGetResponseType,
      "SupplierId" | "RetailerId" | "initiator"
    >,
  ) => {
    return db.draftOrders
      .where({
        SupplierId: Number(order.SupplierId),
        RetailerId: Number(order.RetailerId),
        initiator: order.initiator,
      })
      .delete();
  };

  return {
    orders,
    deleteOrder,
  };
}
